<template>
  <section class="section-base form-section-base">
    <v-container>
      <div class="form-base">
        <v-row>
          <v-col cols="12">
            <div class="form-base__title">
              {{ Text.refusalDetailsTitle }}
            </div>
          </v-col>
        </v-row>

        <BankDetails :v="$v.accountBankDetails" />

        <v-row>
          <v-col cols="12">
            <v-checkbox
              v-model="storageAcceptDetails.hasPrivilege"
              label="Наличие льготы"
              hide-details
            />
          </v-col>
          <v-col v-if="storageAcceptDetails.hasPrivilege" cols="12">
            <v-textarea
              v-model="$v.storageAcceptDetails.note.$model"
              :errorMessages="
                getValidationErrorText($v.storageAcceptDetails.note)
              "
              outlined
              label="Примечание (основание для льготы, при наличии)"
            />
            <span class="text-small-size">
              {{ Text.hasPrivilegeNote }}
            </span>
          </v-col>
        </v-row>
      </div>

      <Footer
        @next-btn-click="btnSaveClickHandler(StepDirection.NEXT)"
        @prev-btn-click="btnSaveClickHandler(StepDirection.PREV)"
        :loading-next="loadingNext"
      />
    </v-container>
  </section>
</template>

<script>
import cloneDeep from 'clone-deep';
import { maxLength, requiredIf } from 'vuelidate/lib/validators';

import { EMOJI, getValidationErrorText } from '@/utils/validate';
import { checkInvalid, leaveStep, Text } from '@/utils/services';
import { ServicesModule } from '@/store/modules/services';
import Footer from '@/components/services/elements/Footer';
import { StepDirection, StepName } from '@/types/services';
import BankDetails, {
  bankDetails,
  bankDetailsValidation,
} from '@/components/services/elements/BankDetails';
import { StorageAcceptStep } from '@/constants';

export default {
  name: 'AccountBankDetails',
  components: {
    Footer,
    BankDetails,
  },
  props: {
    loadingNext: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    StepDirection,
    Text,
    StepName,
    leaveStep,
    getValidationErrorText,
    invalidFields: [],
    accountBankDetails: cloneDeep(bankDetails),
    storageAcceptDetails: {
      hasPrivilege: false,
      note: '',
    },
  }),
  validations() {
    return {
      accountBankDetails: bankDetailsValidation,
      storageAcceptDetails: {
        note: {
          required: requiredIf(() => this.storageAcceptDetails.hasPrivilege),
          maxLength: maxLength(4000),
          EMOJI,
        },
      },
    };
  },
  created() {
    this.prefillDraft();
  },
  methods: {
    prefillDraft() {
      const SABD = ServicesModule.statement.accountBankDetails;
      const SSAD = ServicesModule.statement.storageAcceptDetails;

      if (SABD) {
        this.accountBankDetails = { ...this.accountBankDetails, ...SABD };
      }

      if (SSAD) {
        this.storageAcceptDetails = {
          ...this.storageAcceptDetails,
          ...SSAD,
        };
      }
    },

    touchFields() {
      this.invalidFields = [];
      this.$v.$touch();
      checkInvalid(this.$v, this.invalidFields);
    },

    assemblyModel() {
      return {
        accountBankDetails: cloneDeep(this.accountBankDetails),
        storageAcceptDetails: cloneDeep(this.storageAcceptDetails),
      };
    },

    btnSaveClickHandler(direction) {
      leaveStep({
        stepThis: this,
        direction,
        step: StorageAcceptStep.BANK_DETAILS,
      });
    },
  },
};
</script>
